import {
  DefaultModalDialog,
  Input,
  Text,
} from '~/common/components/defaultUIComponents';
import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { formatEmployeeUsername } from './utils';
import React, { useState } from 'react';

type Props = {
  isOpen: boolean;
  onToggle: () => void;
  employee: Employee;
};

export const DeleteEmployeeModal: React.FC<Props> = ({
  isOpen,
  onToggle,
  employee,
}) => {
  const { mutateAsync: deleteEmployee } = EmployeeApi.hooks.useDeleteEmployee();

  const [employeeToDeleteInput, setEmployeeToDeleteInput] = useState('');
  return (
    <DefaultModalDialog
      dialogHeaderText="employeeTile.deleteEmployee.dialogHeaderText"
      submitText="defaultAlertDialog.defaultActionText"
      isOpen={isOpen}
      onCancel={onToggle}
      onSubmit={() => deleteEmployee(employee).then(onToggle)}
      showCancelButton
      size="lg"
      submitButtonDangerVariant
      disableSubmitButton={
        employeeToDeleteInput !== formatEmployeeUsername(employee)
      }
      initialValues={{}}
    >
      <Text fontWeight="bold" mb={2}>
        employeeTile.deleteEmployee.warning
      </Text>
      <Input
        label={'employeeTile.deleteEmployee.confirmDeleting'}
        labelParams={[formatEmployeeUsername(employee)]}
        placeholder=""
        onChange={(value) =>
          setEmployeeToDeleteInput(value.target.value.trim())
        }
      />
    </DefaultModalDialog>
  );
};
